if (window.PgProductForm) window.PgProductForm.initProductForm();
else {
  class a {
    constructor() {
      this.initProductForm();
    }
    initProductForm() {
      this.quantityListeners(),
        this.variantListeners(),
        this.addToCartListeners();
    }
    quantityListeners() {
      var e = document.querySelectorAll(".pg__plus"),
        t = document.querySelectorAll(".pg__minus");
      for (const r of e)
        window.Pg.keyupAndClickHandler(r, "click", () =>
          this.plusQuantityHandlers(r)
        ),
          window.Pg.keyupAndClickHandler(r, "keyup", () =>
            this.plusQuantityHandlers(r)
          );
      for (const a of t)
        window.Pg.keyupAndClickHandler(a, "click", () =>
          this.minusQuantityHandlers(a)
        ),
          window.Pg.keyupAndClickHandler(a, "keyup", () =>
            this.minusQuantityHandlers(a)
          );
    }
    plusQuantityHandlers(e) {
      var e = e.parentElement.querySelector(".product_quantity"),
        t = parseInt(e.max) || null,
        r = parseInt(e.value);
      e.value = !t || r + 1 <= t ? r + 1 : t;
    }
    minusQuantityHandlers(e) {
      var e = e.parentElement.querySelector(".product_quantity"),
        t = parseInt(e.value);
      e.value = 1 <= t - 1 ? t - 1 : 1;
    }
    variantListeners() {
      var e = document.querySelectorAll(".pg__variant-one"),
        t = document.querySelectorAll(".pg__variant-two"),
        r = document.querySelectorAll(".pg__variant-three");
      for (const a of e)
        a.addEventListener("change", () => this.productVariantListener(a));
      for (const n of t)
        n.addEventListener("change", () => this.productVariantListener(n));
      for (const o of r)
        o.addEventListener("change", () => this.productVariantListener(o));
    }
    productVariantListener(e) {
      var t = e.dataset.productId,
        r = document.getElementById("pg__product-variant-selector-" + t),
        a = document.querySelector(`.pg__price[data-product-id="${t}"]`),
        n = document.querySelector("#pg__quantity-" + t),
        o = document.querySelector("#product-submit-" + t),
        i = document.querySelector("#pg__shop-in-stock-" + t);
      if (e.checked || 0 < e.value.length) {
        var d,
          e =
            document.querySelector(
              `.pg__variant-one[data-product-id="${t}"]:checked`
            ) ||
            document.querySelector(`.pg__variant-one[data-product-id="${t}"]`),
          s =
            document.querySelector(
              `.pg__variant-two[data-product-id="${t}"]:checked`
            ) ||
            document.querySelector(`.pg__variant-two[data-product-id="${t}"]`),
          t =
            document.querySelector(
              `.pg__variant-three[data-product-id="${t}"]:checked`
            ) ||
            document.querySelector(
              `.pg__variant-three[data-product-id="${t}"]`
            ),
          u = null != e ? e.value : "",
          c = null != s ? s.value : "",
          l = null != t ? t.value : "";
        for (d of r)
          d.dataset.optionOne === u &&
            d.dataset.optionTwo === c &&
            d.dataset.optionThree === l &&
            ((d.selected = !0),
            d.hasAttribute("data-managed-inventory")
              ? (a && (a.innerHTML = d.dataset.priceData),
                n && (n.value = (parseInt(d.dataset.inventory), 1)),
                n && (n.max = parseInt(d.dataset.inventory)),
                i &&
                  (i.innerText =
                    0 < parseInt(d.dataset.inventory)
                      ? d.dataset.inventory + " in stock"
                      : "Out of stock"),
                0 < parseInt(d.dataset.inventory)
                  ? (o && o.removeAttribute("disabled"),
                    o && (o.innerText = "Add to Cart"))
                  : (o && o.setAttribute("disabled", ""),
                    o && (o.innerText = "Out of stock")))
              : (a && (a.innerHTML = d.dataset.priceData),
                n && (n.value = 1),
                n && (n.max = "")));
      }
    }
    addToCartListeners() {
      for (const e of document.querySelectorAll(".pg__product-form"))
        e.addEventListener("submit", (e) => {
          e.preventDefault(), e.stopPropagation(), this.addToCartHandlers(e);
        });
    }
    addToCartHandlers(e) {
      var t = e.target.getAttribute("id").split("pg__product-form-")[1],
        r =
          e.target.querySelector("#pg__product-variant-selector-" + t) || null,
        a =
          e.target.querySelector('[name="properties[Recipients]"]') &&
          "" != e.target.querySelector('[name="properties[Recipients]"]').value
            ? e.target.querySelector('[name="properties[Recipients]"]').value
            : null,
        r = null !== r ? r.value : null,
        e = parseInt(e.target.querySelector("#pg__quantity-" + t).value),
        r = null != r ? r : t;
      0 !== r.length
        ? fetch("/cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              items: [
                {
                  quantity: e,
                  id: parseInt(r),
                  ...(a && { properties: { Recipients: a } }),
                },
              ],
            }),
          })
            .then((e) => e.json())
            .then((e) => {
              e.status
                ? window.Pg.createNotification(e.description, "message")
                : (window.Pg.getCartState(),
                  window.Pg.createNotification(
                    "Item successfully added to your cart!",
                    "success"
                  ));
            })
            .catch((e) => {
              window.Pg.createNotification(
                "There was an issue when trying to add the item to your shopping bag. Please refresh and try again. If the issue persists, please contact us!",
                "error"
              );
            })
        : window.Pg.createNotification(
            "Please select a valid product option",
            "message"
          );
    }
  }
  window.PgProductForm = new a();
}
